import UI from "components/UI";
import $ from "jquery";
import {observer} from "mobx-react";
import React from "react";
import InputMask from "react-input-mask";
import ObjectUtil from "utils/ObjectUtil";
import StringUtil from "utils/StringUtil";
import {ValidationRuleNames} from "../../common/validation/rules/ValidationRule";
import useUIValidator from "../../common/validation/component/UseUIValidator";
import {ValidationRuleBytesProps} from "../../common/validation/rules/ValidationRuleBytes";
import classNames from "classnames";

export interface UIInputMaskProps {
    mask: string;
    value?: string;
    valueChanged?: (value: string) => void;
    attrs?: InputMaskOptions;
    readOnly?: boolean;
    displayOnly?: boolean;
    style?: React.CSSProperties;
    inputRender?: () => React.ReactElement;
    className?: string;
    rules?: Array<ValidationRuleNames | ((value: any) => string | undefined)>;
    bytes?: ValidationRuleBytesProps;
}

export default observer(UIInputMask);

function UIInputMask(props: UIInputMaskProps) {
    const attrs: InputMaskOptions = {...props.attrs};
    const {required, valueChecker, errorClassName, setElement} = useUIValidator({rules: props.rules, bytes: props.bytes})
    const refInput = React.useRef<HTMLInputElement>(null);

    let $displaySpan;
    let $hiddenRef;

    React.useEffect(() => {
        if ($displaySpan != null && $hiddenRef != null) {
            $displaySpan.text($hiddenRef.val());
        }
    });

    React.useEffect(() => {
        valueChecker.setValue(props.value == null ? "" : props.value);
    }, [props.value]);

    React.useEffect(() => {
        setElement(refInput.current);
    }, [refInput])

    attrs.maskChar = ObjectUtil.defaultIfNull(attrs.maskChar, "_");

    return (
        <>
            <InputMask
                className={classNames(props.className, {"tf-error": refInput.current?.ariaInvalid === "true"})}
                mask={props.mask}
                {...attrs}
                value={props.value == null ? "" : props.value}
                readOnly={props.readOnly}
                onChange={(event) => {
                    if (props.valueChanged != null) {
                        if (attrs.maskChar != null && attrs.maskChar !== "") {
                            props.valueChanged(StringUtil.replaceAll(event.currentTarget.value, attrs.maskChar, ""));
                        } else {
                            props.valueChanged(event.currentTarget.value);
                        }
                    }
                }}
            >
                {(inputProps) => {
                    if (props.displayOnly === true) {
                        return <input type="hidden" className={props.className}
                                      ref={(element) => ($hiddenRef = $(element!))}/>;
                    }

                    if (props.inputRender != null) {
                        return props.inputRender();
                    }

                    return <input type="text" className={props.className} title={props.value == null ? "" : props.value}
                                  ref={refInput}
                                  readOnly={props.readOnly}
                                  style={props.style}
                                  required={required}
                                  data-security={"off"}
                                  data-value-rule={props.rules}
                                  data-value-bytes={props.bytes}
                                  data-validation-message={valueChecker.message}
                    />;
                }}
            </InputMask>

            <UI.If test={props.displayOnly === true}>
                <span ref={(element) => ($displaySpan = $(element!))}/>
            </UI.If>
        </>
    );
}

export interface InputMaskOptions {
    maskChar?: string;
    formatChars?: string;
    alwaysShowMask?: boolean;
}
